<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 22 20"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M12.7071 19.7071L21.7071 10.7071C22.0976 10.3166 22.0976 9.68342 21.7071 9.29289L12.7071 0.292893C12.3166 -0.0976311 11.6834 -0.0976311 11.2929 0.292893C10.9024 0.683417 10.9024 1.31658 11.2929 1.70711L18.5858 9H1C0.447715 9 0 9.44772 0 10C0 10.5523 0.447715 11 1 11H18.5858L11.2929 18.2929C10.9024 18.6834 10.9024 19.3166 11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071Z" :fill="fill" fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowRight',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
